<template>
    <div>
        <ul :class="$style.listContainer">
            <li
                v-for="(analysisItem, analysisItemIndex) in dirtyVisibleAnalysis"
                :key="analysisItem.analysisId"
                :class="[
                    $style.listItem,
                    dirtySelectedTabIndex === analysisItemIndex
                    ? $style.activeListItem : null,
                ]"
                @click="selectAnalysis(analysisItemIndex)"
            >
                <b-tooltip
                    :active="analysisItem.title.length > 14"
                    :label="analysisItem.title.toUpperCase()"
                >
                    {{ getAnalysisTitle(analysisItem.title) }}
                </b-tooltip>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {cloneDeep as _cloneDeep} from 'lodash';
import {AuditReportAnalysis} from '@/store/modules/audits/types/audits.types';

@Component({})
export default class AnalysisNavigationTabs extends Vue {
    @Prop()
    public visibleAnalysis!: AuditReportAnalysis[];
    @Prop()
    public selectedTabIndex!: number;

    public dirtyVisibleAnalysis: AuditReportAnalysis[] = [];
    public dirtySelectedTabIndex: number = 0;

    public mounted() {
        this.dirtyVisibleAnalysis = _cloneDeep(this.visibleAnalysis);
        this.dirtySelectedTabIndex = this.selectedTabIndex;
    }

    public selectAnalysis(analysisItemIndex: number) {
        this.$emit('selectAnalysis', analysisItemIndex);
    }

    public getAnalysisTitle(analysisTitle: string): string {
        if (analysisTitle.length > 14) {
            return `${analysisTitle.substring(0, 12)} ...`.toUpperCase();
        }
        return analysisTitle.toUpperCase();
    }
}
</script>

<style lang="scss" module>
    .listContainer {
        display: flex;
        flex-direction: row;
    }
    .listItem {
        width: 150px;
        text-align: center;
        color: #9F9F9F;
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 10px;
        cursor: pointer;
    }
    .activeListItem {
        color: #00205B;
        border-bottom: 2px solid #00205B;
    }
</style>
